/* FSR: product recommendations in the cart drawer. Fetches the cart-drawer
   section through the product recommendations endpoint (data-url) and swaps
   in the rendered card carousel. Stays hidden when nothing comes back. */
if (!customElements.get('fsr-cart-recommendations')) {
  class FsrCartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url) return;
      this.dataset.loaded = 'true';
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const grid = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-fsr-recommendations]');
          if (!grid || !grid.querySelector('product-card')) return;
          const target = this.querySelector('[data-fsr-recommendations]');
          if (!target) return;
          target.innerHTML = grid.innerHTML;
          this.classList.remove('hidden');
          // swiper-component only initialises itself on window load, which
          // has long passed here, so kick the carousel and the card media
          // sliders manually
          this.querySelectorAll('swiper-component').forEach(el => {
            if (typeof el.init === 'function') el.init();
          });
        })
        .catch(() => {});
    }
  }
  customElements.define('fsr-cart-recommendations', FsrCartRecommendations);
}
